import * as React from 'react';

import styled from '@emotion/styled';

const Svg = styled.svg`
  width: 23.884px;
  height: 23.884px;
`;

const ToggleIcon = () => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg">
        <g fill="#0076ce">
            <path d="M11.94 23.88A11.94 11.94 0 100 11.94a11.94 11.94 0 0011.94 11.94zm0-22.38A10.44 10.44 0 111.5 11.94 10.45 10.45 0 0111.94 1.5z" />
            <path d="M8.7 13.82l3.24-3.42 3.24 3.42a1 1 0 001.46 0 1.15 1.15 0 000-1.55l-3.97-4.21a1.02 1.02 0 00-.33-.24.96.96 0 00-.8 0 1.01 1.01 0 00-.33.24l-3.97 4.21a1.14 1.14 0 000 1.55 1 1 0 001.46 0z" />
        </g>
    </Svg>
  );
};

export default ToggleIcon;
